import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export type CrmNotification = {
  id: number;
  type: string;
  entityType: 'query' | 'followup' | 'whatsapp_message';
  entityId: number | null;
  title: string;
  body: string;
  deepLink: string;
  readAt?: string | null;
  createdAt: string;
  metadata?: Record<string, unknown>;
};

const normalize = (notification: any): CrmNotification => ({
  id: Number(notification.id),
  type: notification.type,
  entityType: notification.entityType || notification.entity_type,
  entityId: notification.entityId ?? notification.entity_id ?? null,
  title: notification.title,
  body: notification.body,
  deepLink: notification.deepLink || notification.deep_link,
  readAt: notification.readAt ?? notification.read_at,
  createdAt: notification.createdAt || notification.created_at,
  metadata: notification.metadata || {},
});

export async function fetchNotifications(): Promise<CrmNotification[]> {
  const response = await fetch(`${API_BASE_URL}/api/notifications`, { headers: getApiHeaders('none') });
  if (!response.ok) throw new Error('Failed to fetch notifications');
  return (await response.json()).map(normalize);
}

export async function markNotificationRead(id: number): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/api/notifications/${id}/read`, { method: 'PATCH', headers: getApiHeaders('json') });
  if (!response.ok && response.status !== 404) throw new Error('Failed to mark notification read');
}
